import "#legacy/embed/doctor_finder.js";

class EmbeddedProviderFindersBehavior extends Sparkle.PageBuilder.Components.Behavior {
  static {
    this.prototype.events = {
      "embedded-provider-finders:load-primary": "loadPrimaryFinder",
      "embedded-provider-finders:load-secondary": "loadSecondaryFinder",
    };
  }

  constructor() {
    super(...arguments);
    this.onRender = this.onRender.bind(this);
    this.initialize = this.initialize.bind(this);
    this.loadPrimaryFinder = this.loadPrimaryFinder.bind(this);
    this.loadSecondaryFinder = this.loadSecondaryFinder.bind(this);
    this.finderOptions = this.finderOptions.bind(this);
    this.resetFinderStateForRerender = this.resetFinderStateForRerender.bind(this);
  }

  onRender() {
    return this.initialize();
  }

  initialize() {
    super.initialize(...arguments);

    this.primaryContainer = this.el.find(".sparkle-doctor-finder-container-primary");
    this.secondaryContainer = this.el.find(".sparkle-doctor-finder-container-secondary");

    return this.resetFinderStateForRerender();
  }

  loadPrimaryFinder() {
    if (this.primaryFinderPromise != null || !this.primaryContainer.length) {
      return this.primaryFinderPromise;
    }

    const container = this.primaryContainer;
    const containerId = container.attr("id");

    const primaryFinderPromise = jQuery.when().then(() => {
      if (this.primaryContainerId !== containerId) {
        return;
      }
      return new Sparkle.Embed.DoctorFinder(containerId, this.finderOptions(container));
    });

    this.primaryFinderPromise = primaryFinderPromise;

    primaryFinderPromise.fail(() => {
      if (this.primaryFinderPromise === primaryFinderPromise) {
        this.primaryFinderPromise = null;
      }
    });

    return primaryFinderPromise;
  }

  loadSecondaryFinder() {
    if (this.secondaryFinderPromise != null || !this.secondaryContainer.length) {
      return this.secondaryFinderPromise;
    }

    const container = this.secondaryContainer;
    const containerId = container.attr("id");

    const secondaryFinderPromise = jQuery.when().then(() => {
      if (this.secondaryContainerId !== containerId) {
        return;
      }
      return new Sparkle.Embed.DoctorFinder(containerId, this.finderOptions(container));
    });

    this.secondaryFinderPromise = secondaryFinderPromise;

    secondaryFinderPromise.fail(() => {
      if (this.secondaryFinderPromise === secondaryFinderPromise) {
        this.secondaryFinderPromise = null;
      }
    });

    return secondaryFinderPromise;
  }

  // HELPER FUNCTIONS

  finderOptions(container) {
    return {
      uuid: container.data("doctor-finder-embed-uuid"),
      landing_page_route: "/",
    };
  }

  resetFinderStateForRerender() {
    const primaryContainerId = this.primaryContainer.attr("id");
    const secondaryContainerId = this.secondaryContainer.attr("id");

    if (this.primaryContainerId != null && this.primaryContainerId !== primaryContainerId) {
      this.primaryFinderPromise = null;
    }

    if (this.secondaryContainerId != null && this.secondaryContainerId !== secondaryContainerId) {
      this.secondaryFinderPromise = null;
    }

    this.primaryContainerId = primaryContainerId;
    this.secondaryContainerId = secondaryContainerId;
  }
}
EmbeddedProviderFindersBehavior.register("embedded_provider_finders");
